import { AdminProductAlternative } from '../model/adminProductAlternative';
export class AdminProductAlternativeBuilder {
    static buildAdminProductAlternative(data) {
        const adminProductAlternative = new AdminProductAlternative();
        adminProductAlternative.id = data.id;
        adminProductAlternative.id_product = data.id_product;
        adminProductAlternative.id_product_extra = data.id_product_extra;
        adminProductAlternative.alternative_id_product = data.alternative_id_product;
        adminProductAlternative.alternative_id_product_extra = data.alternative_id_product_extra;
        adminProductAlternative.message_es = data.message_es;
        adminProductAlternative.message_ca = data.message_ca;
        adminProductAlternative.message_en = data.message_en;
        adminProductAlternative.message_fr = data.message_fr;
        adminProductAlternative.description_es = data.description_es;
        adminProductAlternative.description_ca = data.description_ca;
        adminProductAlternative.description_en = data.description_en;
        adminProductAlternative.description_fr = data.description_fr;
        adminProductAlternative.warning_es = data.warning_es;
        adminProductAlternative.warning_ca = data.warning_ca;
        adminProductAlternative.warning_en = data.warning_en;
        adminProductAlternative.warning_fr = data.warning_fr;
        return adminProductAlternative;
    }
}
//# sourceMappingURL=adminProductAlternative-builder.js.map